import { Input } from '@/components/ui/input';

// Opción 1 completa · cómo se cobra el envío de este producto (lo gestiona el vendedor).
export const SHIPPING_TYPES = [
  { value: 'seller_rate', label: 'Tarifa por zonas (mi configuración de envíos)' },
  { value: 'custom', label: 'Valor de envío personalizado' },
  { value: 'automarket_rate', label: 'Tarifa estándar de AutoMarket' },
  { value: 'free', label: 'Envío gratis (lo asumo yo)' },
];

export const shippingFromProduct = (p) => ({
  shipping_price_type: p?.shipping_price_type || (p?.free_shipping ? 'free' : 'seller_rate'),
  custom_shipping_price: p?.custom_shipping_price != null ? String(p.custom_shipping_price) : '',
});

export const shippingPayload = (form) => {
  const t = form.shipping_price_type || 'seller_rate';
  const n = parseFloat(form.custom_shipping_price);
  return {
    shipping_price_type: t,
    custom_shipping_price: t === 'custom' && Number.isFinite(n) ? n : null,
    free_shipping: t === 'free',
  };
};

export const ProductShippingType = ({ form, setForm }) => (
  <div className="mt-2" data-testid="seller-product-shipping-type-block">
    <div className="text-[11px] text-slate-500">Cobro del envío</div>
    <select className="mt-1 h-9 w-full border border-slate-300 bg-white px-2 text-sm" value={form.shipping_price_type}
      onChange={(e) => setForm({ ...form, shipping_price_type: e.target.value })} data-testid="seller-product-shipping-type">
      {SHIPPING_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
    </select>
    {form.shipping_price_type === 'custom' && (
      <Input type="number" min="1" placeholder="Valor del envío (COP)" value={form.custom_shipping_price}
        onChange={(e) => setForm({ ...form, custom_shipping_price: e.target.value })}
        className="rounded-none mt-2" data-testid="seller-product-custom-shipping-price" />
    )}
    <p className="mt-1 text-[11px] text-slate-400">
      Si el pedido combina varios tipos, se cobra un solo envío: el valor más alto. «Gratis» solo aplica si todos los productos del pedido son gratis.
    </p>
  </div>
);
